var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.614 10.3636C18.614 12.9258 16.9488 15.4021 15.1377 17.3137C14.2475 18.2534 13.3548 19.0224 12.6837 19.5568C12.4143 19.7713 12.1815 19.9473 12.0004 20.0804C11.8192 19.9473 11.5864 19.7713 11.317 19.5568C10.6459 19.0224 9.7532 18.2534 8.863 17.3137C7.05193 15.4021 5.38672 12.9258 5.38672 10.3636C5.38672 6.71103 8.34774 3.75 12.0004 3.75C15.653 3.75 18.614 6.71103 18.614 10.3636Z",
    stroke: "#2B323B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0004 12.8183C13.3561 12.8183 14.455 11.7193 14.455 10.3637C14.455 9.00812 13.3561 7.90918 12.0004 7.90918C10.6448 7.90918 9.5459 9.00812 9.5459 10.3637C9.5459 11.7193 10.6448 12.8183 12.0004 12.8183Z",
    stroke: "#2B323B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.0ab204c9de96d7e0409c26b234d69f14.svg";
export { ForwardRef as ReactComponent };